<template>
  <div class="page-content expense-details clearfixing">
    
    <!-- BREADCRUMB -->
    <f-p-breadcrumb
      :breadcrumbOuter="$lang.messages.payments.toUpperCase()"
      :breadcrumbTo="'Recurring'"
      :breadcrumbToTitle="$lang.messages.recurring"
      :breadcrumbInner="$lang.messages.expenseDetails.toUpperCase()"
      :breadcrumbIsHistory="false">
    </f-p-breadcrumb>
    
    <fp-recurring-expenses-details
      :guid="guid"
      :sidebarExpandedProp="sidebarExpandedProp">
    </fp-recurring-expenses-details>
    
  </div>
</template>

<script>
  import FpRecurringExpensesDetails from '@/components/common/FPRecurringExpensesDetails';
  import FPBreadcrumb from "@/components/common/FPBreadcrumb";
  
  export default {
    name: 'spousalMaintenanceRecurringExpensesDetails',
    components: {
      FpRecurringExpensesDetails,
      'f-p-breadcrumb': FPBreadcrumb
    },
    props: {
      sidebarExpandedProp: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        guid: this.$route.params.id,
      }
    }
  }
</script>
